'use client';

import type { PageMagArticleStoryblok } from '@/types/component-types-sb';
import type { ISbStoryData } from '@storyblok/react/rsc';
import React, { createContext, useContext } from 'react';

// Create the context with a default value of null
const MagazineTrendCardsContext = createContext<(string | ISbStoryData<PageMagArticleStoryblok>)[] | null>(null);

// Define the MagazineTrendCardsProvider as a functional component
const MagazineTrendCardsProvider: React.FC<{
  value: (string | ISbStoryData<PageMagArticleStoryblok>)[] | null;
  children: React.ReactNode;
}> = ({ value, children }) => {
  return <MagazineTrendCardsContext.Provider value={value}>{children}</MagazineTrendCardsContext.Provider>;
};

// Custom hook to use the context
export const useMagazineTrendCardsProvider = () => {
  const context = useContext(MagazineTrendCardsContext);
  if (context === undefined) {
    throw new Error('useMagazineTrendCardsProvider must be used within an MagazineTrendCardsProvider');
  }
  return context;
};

export default MagazineTrendCardsProvider;
